import type { CSSProperties, ReactNode } from "react";

import { Icon, type IconName } from "./Icon";

type Variant = "default" | "accent" | "ok" | "warn" | "bad" | "outline" | "solid";

export interface PillProps {
  children?: ReactNode;
  variant?: Variant;
  icon?: IconName;
  className?: string;
  style?: CSSProperties;
}

const VARIANT: Record<Variant, string> = {
  default: "bg-n-100 text-n-700 border-n-200",
  accent: "bg-a-50 text-a-700 border-a-200",
  ok: "bg-ok-bg text-ok border-[#b8dbc1]",
  warn: "bg-warn-bg text-warn border-[#efd9a6]",
  bad: "bg-bad-bg text-bad border-[#efc1b7]",
  outline: "bg-transparent text-n-600 border-n-200",
  solid: "bg-n-900 text-white border-n-900",
};

export function Pill({
  children,
  variant = "default",
  icon,
  className = "",
  style,
}: PillProps): ReactNode {
  return (
    <span
      style={style}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-[7px] py-[2px] text-[11px] font-medium tracking-[-0.05px] leading-[1.5] ${VARIANT[variant]} ${className}`}
    >
      {icon && <Icon name={icon} size={11} />}
      {children}
    </span>
  );
}
